import * as Notifications from 'expo-notifications'
import { Platform } from 'react-native'
import Constants from 'expo-constants'
import { apiFetch } from './api'

// Suppress the native system banner in the foreground — we show our own
// custom in-app banner instead (see _layout.tsx addNotificationReceivedListener).
// shouldShowList: true keeps the notification in the tray / notification
// centre so the user can still find it after the in-app banner auto-dismisses.
// shouldPlaySound: true preserves the audio cue even without the visual banner.
Notifications.setNotificationHandler({
  handleNotification: async (notification) => ({
    shouldShowAlert: notification.request.content.data?.kind === 'SUPPORT_TICKET',
    shouldShowBanner: notification.request.content.data?.kind === 'SUPPORT_TICKET',
    shouldShowList: true,
    shouldPlaySound: true,
    shouldSetBadge: false,
  }),
})

export async function registerForPushNotifications(): Promise<string | null> {
  if (Platform.OS === 'web') return null

  const { status: existingStatus } = await Notifications.getPermissionsAsync()
  let finalStatus = existingStatus

  if (existingStatus !== 'granted') {
    const { status } = await Notifications.requestPermissionsAsync()
    finalStatus = status
  }

  if (finalStatus !== 'granted') return null

  const projectId = Constants.expoConfig?.extra?.eas?.projectId as string | undefined
  if (!projectId) {
    console.warn('No EAS project ID configured — push notifications will not work')
    return null
  }

  try {
    const tokenData = await Notifications.getExpoPushTokenAsync({ projectId })
    return tokenData.data
  } catch {
    return null
  }
}

export async function syncPushToken(token: string): Promise<void> {
  await apiFetch('/api/v1/users/me/push-token', {
    method: 'POST',
    body: JSON.stringify({ token }),
  })
}
